import React, { useEffect, useState } from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import ForecastDiarizado from "../../../components/classes/ForecastDiarizado";
import ForecastDiarioMoverPlanoModalTopo from "./forecastDiarioMoverPlanoModalTopo";
import ForecastDiarioMoverPlanoModalDetalhe from "./forecastDiarioMoverPlanoModalDetalhe";

import { useTranslation } from "react-i18next";

export default function ForecastDiarioMoverPlanoModal(
  props: ForecastDiarioMoverPlanoModalPropsTypes
) {
  const { t } = useTranslation();

  const [forecastAtual, setForecastAtual] = useState<ForecastDiarizado>(() => {
    let initialState = props.forecastsDiarizados?.find(
      (item) => item.id == props.idForecastAtual
    );
    return initialState!;
  });

  return (
    <>
      <div className="containerForecastModal" style={{ width: "30vw" }}>
        <div className="containerTitleModal">
          <ForecastDiarioMoverPlanoModalTopo />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("pages.dailyForecast.text.exitModal")}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <ForecastDiarioMoverPlanoModalDetalhe
            forecastDiarizadoAtual={forecastAtual}
            forecastsDiarizados={props.forecastsDiarizados}
            setPlanoFoiMovido={props.setPlanoFoiMovido}
            handleClose={props.handleClose}
          />
        </div>
      </div>
    </>
  );
}

interface ForecastDiarioMoverPlanoModalPropsTypes {
  handleClose: any;
  setPlanoFoiMovido: any;
  forecastsDiarizados?: ForecastDiarizado[];
  idForecastAtual: number;
}
